import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { updateCollectionByPath } from '../../modules/actions';

export const useSettingsFaceRecognition = () => {
  const dispatch = useDispatch();
  const [faceRecognitionModalIsOpen, setFaceRecognitionModalIsOpen] = useState(false);

  const changeFaceRecognition = useCallback(
    (value: boolean) => {
      const updatedAt = moment().toLocaleString();

      dispatch(
        updateCollectionByPath({
          path: 'faceRecognition',
          value: { enabled: value, updatedAt }
        })
      );
    },
    [dispatch]
  );

  // turning OFF needs a confirmation modal, turning ON is immediate
  const handleFaceRecognitionSwitch = useCallback(
    (value: boolean) => {
      if (value) {
        changeFaceRecognition(value);
      } else {
        setFaceRecognitionModalIsOpen(true);
      }
    },
    [changeFaceRecognition]
  );

  const onFaceRecognitionModalConfirm = useCallback(
    () => changeFaceRecognition(false),
    [changeFaceRecognition]
  );
  const closeFaceRecognitionModal = useCallback(() => setFaceRecognitionModalIsOpen(false), []);

  return {
    faceRecognitionModalIsOpen,
    handleFaceRecognitionSwitch,
    onFaceRecognitionModalConfirm,
    closeFaceRecognitionModal
  };
};
